import { css } from 'styled-components';

export const ellipsis = css`
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
`;
